<div class="box-body p-0">
  <mat-menu #singleactions="matMenu" xPosition="before">
    <button mat-menu-item class="text-success" *ngIf="notiState?.notification?.status === 'UNREAD'"
            (click)="markAsRead()">
      <mat-icon class="text-success">done</mat-icon>
      <span>Mark as read</span>
    </button>
    <button mat-menu-item class="text-danger" (click)="deleteNotification()">
      <mat-icon class="text-danger">delete</mat-icon>
      <span>Delete</span>
    </button>
  </mat-menu>

  <!-- Content -->
  <!-- Mention 1 -->
  <div class="p-2 d-flex align-items-center border-bottom"
       [class.unread]="notiState?.notification?.status === 'UNREAD'">
    <div class="ns-avatar ns-cursor mr-3" routerLink="/{{notiState?.notification?.users[0]?.handle}}">
      <img *ngIf="!notiState?.notification?.users[0]?.photoURL" class="rounded-circle" src="https://picsum.photos/196"
           alt="">
      <img *ngIf="notiState?.notification?.users[0]?.photoURL" class="rounded-circle"
           [src]="notiState?.notification?.users[0]?.photoURL" alt="">
    </div>
    <div class="mr-3">
      <div class="" routerLink="/{{notiState?.notification?.users[0]?.handle}}">
        <span class="font-weight-bold ns-cursor">{{notiState?.notification.users[0]?.name}}</span>&nbsp;
        <span class="text-success ns-cursor">@{{notiState?.notification?.users[0]?.handle}}</span>&nbsp;
        <span class="text-muted text-truncate">● {{notiState?.notification?.timestamp | postTime}}</span>
      </div>
      <div (click)="openPost()" class="ns-cursor" *ngIf="notiState?.notification?.action === 'MENTION'">
        Mentioned you in a scroll
      </div>
      <div (click)="openPost()" class="ns-cursor" *ngIf="notiState?.notification?.action === 'ECHO'">
        Rescribed your scroll
      </div>

      <div (click)="openPost()" class="ns-cursor" *ngIf="notiState?.notification?.action === 'COMMENT'">
        Commented on your scroll
      </div>

      <div (click)="openPost()" class="ns-cursor" *ngIf="notiState?.notification?.action === 'FAVORITE'">
        Favourited your scroll
      </div>

      <div (click)="openPost()" class="ns-cursor" *ngIf="notiState?.notification?.action === 'UPVOTE'">
        Up voted your scroll
      </div>

      <div (click)="openPost()" class="ns-cursor" *ngIf="notiState?.notification?.action === 'DOWNVOTE'">
        Down voted your scroll
      </div>

      <div (click)="openPost()" class="ns-cursor" *ngIf="notiState?.notification?.action === 'FLAG'">
        Flagged your scroll
      </div>

      <div class="ns-cursor" *ngIf="notiState?.notification?.action === 'FOLLOW'">
        Followed you
      </div>

      <div class="ns-cursor" *ngIf="notiState?.notification?.action === 'REPLY'">
        Replied to your comment
      </div>

      <div class="ns-cursor" *ngIf="notiState?.notification?.action === 'INVITE'">
        Invited you
      </div>

    </div>
    <span class="ml-auto mb-auto">
      <button mat-icon-button [matMenuTriggerFor]="singleactions">
        <mat-icon>more_horiz</mat-icon>
      </button>

      <br>
      <div class="text-right text-muted pt-1 small ns-time"></div>
    </span>
  </div>
</div>
